import { Box, useMediaQuery } from '@mui/material';
import { BalanceSectionHeader } from './BalanceSectionHeader';
import { mobileWidth } from '@/constants';
import { useLocalization } from '@/hooks/useLocalization';

interface BalanceChartLayoutProps {
  assetsTotal: number;
  liabilitiesTotal: number;
  assetsChart: React.ReactNode;
  liabilitiesChart: React.ReactNode;
  forceColumnLayout?: boolean;
}

export const BalanceChartLayout = ({
  assetsTotal,
  liabilitiesTotal,
  assetsChart,
  liabilitiesChart,
  forceColumnLayout = false,
}: BalanceChartLayoutProps) => {
  const isMobileMatch = useMediaQuery(mobileWidth);
  const { t } = useLocalization();
  return (
    <Box
      display='flex'
      flexDirection={isMobileMatch || forceColumnLayout ? 'column' : 'row'}
      justifyContent='space-between'
      gap={isMobileMatch ? 5 : 4}
      className='balance-chart-layout'
    >
      <Box
        flex={1}
        px={isMobileMatch ? 2 : 0}
        py={isMobileMatch ? 2 : 0}
        className='print-section print-section-assets'
      >
        <BalanceSectionHeader
          title={t('assets')}
          amount={assetsTotal}
        />
        {assetsChart}
      </Box>
      <Box
        flex={1}
        px={isMobileMatch ? 2 : 0}
        py={isMobileMatch ? 2 : 0}
        className='print-section print-section-liabilities'
      >
        <BalanceSectionHeader
          title={t('liabilities')}
          amount={liabilitiesTotal}
        />
        {liabilitiesChart}
      </Box>
    </Box>
  );
};
